import React from "react";
import styled from "styled-components";

import { ReactComponent as CloseIcon } from "../../Assets/iconsv2/generic/closeBtn.svg";
import { useTranslate } from '@tolgee/react';
import PrimaryButton from "../GenericComponents/PrimaryButton";

const MeetingDetailsHeader = ({ handleClose, infoChanged, handleSave, }) => {
  const { t } = useTranslate();
  return (
    <Container>
      <LeftSection>

        <Text>
          <h1>{t('general.details')}</h1>
        </Text>

      </LeftSection>
      <RightSection>
        {infoChanged && (
          <PrimaryButton onClick={() => handleSave()}>{t('general.save')}</PrimaryButton>
        )}
        <CloseBtn onClick={handleClose}>
          <CloseIcon />
        </CloseBtn>
      </RightSection>
    </Container>
  );
};

export default MeetingDetailsHeader;

const Container = styled.div`
display:flex;
justify-content:space-between;
padding: 19px 16px;
align-items:center;
  background: ${({ theme }) => theme.chat.conversationBackground};
border-bottom:1px solid ${({ theme }) => theme.sidebar.borderColor};
gap:20px;
`;

const LeftSection = styled.div`
  display: flex;
  align-items: center;
  gap: 15px;
`;

const Text = styled.div`
  display: flex;
  flex-direction: column;
  overflow: hidden;
  h1 {
    text-transform: capitalize;
   font-weight: 700;
font-size: 20px;
line-height:32px;
letter-spacing: 0.04px;
color:${({ theme }) => theme.menu.primaryTextColor};
  }
`;

const CloseBtn = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  background: none;
  cursor: pointer;
  svg{
height:26px;
width:26px;
color:${({ theme }) => theme.menu.selectedOpionBackground};
stroke:${({ theme }) => theme.sidebar.borderColor};
}
`;

const RightSection = styled.div`
mergin-left:auto;
  display: flex;
  align-items: center;
  gap: 15px;
`